import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ApiError } from "aws-amplify/api";
import { environment } from "src/environments/environment";
import { ToastService } from "src/app/shared/services/toast.service";
import { TranslateService } from "@ngx-translate/core";
import { map, catchError, throwError, of } from "rxjs";
import { UnclaimCasesResponseApiModel } from "./models/unclaim-cases-response-api";
import { mapFiledCaseResponseToUIModel } from "./mappers/mapFiledCaseResponseApiToUiModel";
import { FiledCaseResponseAPI } from "./models/filed-case.response-api.model";
import { mapUnClaimResponseToUIModel } from "./mappers/mapUnClaimResponseApiToUiModel";
import { DashboardFilter } from "./models/filter.model";
import { ProviderCaseStatusGetDTO } from "../providers/provider.model";
import { NoShowToastContext } from "src/app/core/interceptors/http-toast.interceptor";

// const caseKPI: FiledCaseResponseAPI = {
//   providerBreakdown: {
//     amazon: {
//       filedCasesTotal: 25,
//       filedCasesAmount: 21300.67,
//       cashReimbursementTotal: 18,
//       cashReimbursementAmount: 9854.51,
//       inventoryReimbursementTotal: 12,
//       inventoryReimbursementAmount: 3105.45,
//       statusBreakdown: {
//         CLOSED: {
//           total: 5,
//           amount: 4250.15,
//           cashReimbAmount: 2550.0,
//           invReimbAmount: 800.5,
//         },
//         CLOSED_INV: {
//           total: 3,
//           amount: 2100.3,
//           cashReimbAmount: 1200.0,
//           invReimbAmount: 650.25,
//         },
//         DELETED: {
//           total: 2,
//           amount: 1500.5,
//           cashReimbAmount: 800.0,
//           invReimbAmount: 300.0,
//         },
//         DENIED: {
//           total: 2,
//           amount: 1200.0,
//           cashReimbAmount: 600.0,
//           invReimbAmount: 250.0,
//         },
//         NOT_FILED: {
//           total: 3,
//           amount: 2800.75,
//           cashReimbAmount: 1304.51,
//           invReimbAmount: 500.0,
//         },
//         PARTIAL_PAYMENT: {
//           total: 4,
//           amount: 3450.42,
//           cashReimbAmount: 1800.0,
//           invReimbAmount: 605.7,
//         },
//         PARTIAL_PAYMENT_CLOSED: {
//           total: 2,
//           amount: 1800.55,
//           cashReimbAmount: 900.0,
//           invReimbAmount: 350.0,
//         },
//         PENDING_SELLER_RESPONSE: {
//           total: 2,
//           amount: 2100.5,
//           cashReimbAmount: 700.0,
//           invReimbAmount: 400.0,
//         },
//         SUBMITTED: {
//           total: 2,
//           amount: 1698.5,
//           cashReimbAmount: 0.0,
//           invReimbAmount: 0.0,
//         },
//         TRANSFERRED: {
//           total: 0,
//           amount: 0.0,
//           cashReimbAmount: 0.0,
//           invReimbAmount: 0.0,
//         },
//       },
//     },
//     walmart: {
//       filedCasesTotal: 18,
//       filedCasesAmount: 15850.4,
//       cashReimbursementTotal: 14,
//       cashReimbursementAmount: 5200.75,
//       inventoryReimbursementTotal: 10,
//       inventoryReimbursementAmount: 2150.5,
//       statusBreakdown: {
//         CLOSED: {
//           total: 4,
//           amount: 3100.25,
//           cashReimbAmount: 1800.0,
//           invReimbAmount: 600.5,
//         },
//         CLOSED_INV: {
//           total: 2,
//           amount: 1500.5,
//           cashReimbAmount: 900.0,
//           invReimbAmount: 400.0,
//         },
//         DELETED: {
//           total: 1,
//           amount: 800.25,
//           cashReimbAmount: 400.0,
//           invReimbAmount: 200.0,
//         },
//         DENIED: {
//           total: 2,
//           amount: 1200.5,
//           cashReimbAmount: 600.0,
//           invReimbAmount: 300.0,
//         },
//         NOT_FILED: {
//           total: 2,
//           amount: 1850.75,
//           cashReimbAmount: 800.0,
//           invReimbAmount: 350.5,
//         },
//         PARTIAL_PAYMENT: {
//           total: 3,
//           amount: 2400.4,
//           cashReimbAmount: 1100.75,
//           invReimbAmount: 400.0,
//         },
//         PARTIAL_PAYMENT_CLOSED: {
//           total: 1,
//           amount: 950.35,
//           cashReimbAmount: 400.0,
//           invReimbAmount: 200.0,
//         },
//         PENDING_SELLER_RESPONSE: {
//           total: 2,
//           amount: 1650.5,
//           cashReimbAmount: 400.0,
//           invReimbAmount: 300.0,
//         },
//         SUBMITTED: {
//           total: 1,
//           amount: 1397.9,
//           cashReimbAmount: 0.0,
//           invReimbAmount: 0.0,
//         },
//         TRANSFERRED: {
//           total: 0,
//           amount: 0.0,
//           cashReimbAmount: 0.0,
//           invReimbAmount: 0.0,
//         },
//       },
//     },
//   },
// };

// const UnFiledClaims: UnclaimCasesResponseApiModel = {
//   providerBreakdown: {
//     amazon: {
//       unclaimedCasesTotal: 28,
//       unclaimedCasesAmountPotential: 35684.52,
//       claimTypeBreakdown: {
//         Lost_Inbound: {
//           total: 6,
//           amountPotential: 8742.5,
//         },
//         Lost_Outbound: {
//           total: 5,
//           amount: 7250.25,
//         },
//         Refunds_Never_Returned_FBA: {
//           total: 8,
//           amount: 12340.75,
//         },
//         Refunds_Outside_Refund_Window_FBM: {
//           total: 4,
//           amount: 3650.52,
//         },
//         Lost_In_Transfer: {
//           total: 3,
//           amount: 2100.0,
//         },
//         Wrong_FBA_Fees: {
//           total: 2,
//           amount: 1600.5,
//         },
//       },
//       statusBreakdown: {
//         NOT_FILED: {
//           total: 28,
//           amount: 35684.52,
//         },
//       },
//     },
//     walmart: {
//       unclaimedCasesTotal: 12,
//       unclaimedCasesAmountPotential: 8920.75,
//       claimTypeBreakdown: {
//         Lost_Inbound: {
//           total: 3,
//           amount: 2450.0,
//         },
//         Lost_Outbound: {
//           total: 2,
//           amount: 1850.25,
//         },
//         Refunds_Never_Returned_FBA: {
//           total: 4,
//           amount: 3150.5,
//         },
//         Wrong_FNSKU: {
//           total: 2,
//           amount: 800.0,
//         },
//         Safe_T_Claim: {
//           total: 1,
//           amount: 670.0,
//         },
//       },
//       statusBreakdown: {
//         NOT_FILED: {
//           total: 12,
//           amount: 8920.75,
//         },
//       },
//     },
//   },
// };

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  protected http = inject(HttpClient);
  protected toast = inject(ToastService);
  protected translate = inject(TranslateService);
  constructor() {}

  getFilledClaim(
    statusApi: ProviderCaseStatusGetDTO[],
    params?: DashboardFilter,
  ) {
    let queryParams = new HttpParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value != null && value !== "") {
          queryParams = queryParams.set(key, String(value));
        }
      });
    }

    return this.http
      .get<FiledCaseResponseAPI>(
        `${environment.baseApiUrl}/cases/dashboard-kpis`,
        {
          params: queryParams,
          ...NoShowToastContext(),
        },
      )
      .pipe(
        map((res: any) => (res as FiledCaseResponseAPI) ?? null),
        map((res) =>
          res ? mapFiledCaseResponseToUIModel(res, statusApi) : null,
        ),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            return of(null);
          }
          this.handlerError(error);
          return throwError(() => error);
        }),
      );
  }
  getUnfilledClaim(params?: DashboardFilter) {
    let queryParams = new HttpParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value != null && value !== "") {
          queryParams = queryParams.set(key, String(value));
        }
      });
    }

    return this.http
      .get<UnclaimCasesResponseApiModel>(
        `${environment.baseApiUrl}/claims/dashboard-kpis`,
        {
          params: queryParams,
          ...NoShowToastContext(),
        },
      )
      .pipe(
        map((res: any) => (res as UnclaimCasesResponseApiModel) ?? null),
        map((res) => (res ? mapUnClaimResponseToUIModel(res) : null)),

        catchError((error) => {
          if (error.status === 404) {
            return of(null);
          }
          this.handlerError(error);
          return throwError(() => error);
        }),
      );
  }

  // getFilledClaimMock(params: { starDate: string; endDate: string }) {
  //   return this.http
  //     .get<FiledCaseResponseAPI>(`/assets/mocks/filed-cases.json`)
  //     .pipe(map((res) => mapFiledCaseResponseToUIModel(res)));
  // }

  private handlerError(error: any) {
    if (error instanceof ApiError) {
      if (error.response) {
        const { statusCode, body } = error.response;
        console.error(
          `Received ${statusCode} error response with payload: ${body}`,
        );
      } else {
        console.error(`Received unknown error response with payload: ${error}`);
      }
    } else {
      console.error("Unexpected error: ", error);
    }
  }
}
